interface IDirectory {
  readonly paths: Path[]
}
interface IPath {
  readonly level?: number
  readonly displayName: string
  readonly route: string
}

export class Path implements IPath {
  readonly level?: number
  readonly displayName: string
  readonly route: string

  constructor({ displayName = '', route, level }: Path) {
    this.level = level
    this.displayName = displayName
    this.route = route
    return {
      ...this,
    }
  }
}

export default class Directory implements IDirectory {
  readonly paths: Path[]

  constructor({ paths }: IDirectory) {
    this.paths = paths
    return {
      ...this,
    }
  }
}
